"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "agentSystemConfig:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['authenticateOptions'])),
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      agentList: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        agentId: "",
        systemName: "",
        systemUrl: "",
        approveStateCode: ""
      },
      fileServerPath: null
    };
  },
  created: function created() {
    var _this = this;

    this.getAgents();
    this.getFilePath();
    this.$nextTick(function (_) {
      _this.getList();
    });
  },
  methods: {
    getFilePath: function getFilePath() {
      var _this2 = this;

      _httpUtils.default.get("agentSystemConfig", "getFilePath").then(function (res) {
        _this2.fileServerPath = res;
      });
    },
    concatFilePath: function concatFilePath(path) {
      var fullPath = "";

      if (this.fileServerPath === null) {
        return;
      } else {
        fullPath = this.fileServerPath + path;
        return fullPath;
      }
    },
    convertAgentName: function convertAgentName(name) {
      var found = "";

      if (this.agentList === null) {
        return;
      }

      this.agentList.forEach(function (status) {
        if (status.agentId == name) {
          found = status.agentName;
          return;
        }
      });
      return found;
    },
    convertAuthenticateName: function convertAuthenticateName(name) {
      var found = "";
      this.authenticateOptions.forEach(function (status) {
        if (status.key === name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    getList: function getList() {
      var _this3 = this;

      if (!this.hasViewPermission) {
        return;
      }

      ;
      this.listLoading = true;

      _httpUtils.default.post("agentSystemConfig", "list", null, this.listQuery).then(function (res) {
        _this3.list = res.data.rows;
        _this3.total = res.data.total;
        setTimeout(function () {
          _this3.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this3.$message({
          type: "error",
          message: err.message
        });
      });
    },
    getAgents: function getAgents() {
      var _this4 = this;

      _httpUtils.default.post("agent", "getAgents", null, null).then(function (res) {
        _this4.agentList = res.data;
        setTimeout(function () {
          _this4.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this4.$message({
          type: "error",
          message: err.message
        });
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    convert: function convert(string) {
      var regexLt = /&lt;/gi,
          regexGt = /&gt;/gi;
      string = string.replace(regexLt, "<");
      string = string.replace(regexGt, ">");
      return string;
    },
    handleApproveSuccess: function handleApproveSuccess(state) {
      var _this5 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === "approve") {
        message = _lang.default.t("message.message21");
        info = _lang.default.t("SMS.alarm");
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t("permission.confirm"),
        cancelButtonText: _lang.default.t("permission.cancel"),
        type: "warning"
      }).then(function () {
        _this5.doApproveSuccessData();
      }).catch(function () {
        _this5.$message({
          type: "info",
          message: _lang.default.t("message.message25")
        });
      });
    },
    handleApproveFail: function handleApproveFail(state) {
      var _this6 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === "reject") {
        message = _lang.default.t("message.message22");
        info = _lang.default.t("SMS.alarm");
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t("permission.confirm"),
        cancelButtonText: _lang.default.t("permission.cancel"),
        type: "warning"
      }).then(function () {
        _this6.doApproveFailData();
      }).catch(function () {
        _this6.$message({
          type: "info",
          message: _lang.default.t("message.message23")
        });
      });
    },
    doApproveSuccessData: function doApproveSuccessData() {
      var _this7 = this;

      var ids = "";

      for (var data in this.multipleSelection) {
        ids = ids === "" ? this.multipleSelection[data].id.toString() : ids.concat("," + this.multipleSelection[data].id.toString());
      }

      _httpUtils.default.post("agentSystemConfig", "approveSuccessAgentConfigs", null, ids).then(function (res) {
        if (res.code === 200) {
          _this7.$notify({
            title: _lang.default.t("SMS.success"),
            message: _lang.default.t("message.message9"),
            type: "success",
            duration: 2000
          });

          _this7.getList();
        } else {
          _this7.$message({
            showClose: true,
            message: _lang.default.t("message.message10"),
            type: "warning"
          });
        }
      }).catch(function (err) {
        _this7.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    doApproveFailData: function doApproveFailData() {
      var _this8 = this;

      var ids = "";

      for (var data in this.multipleSelection) {
        ids = ids === "" ? this.multipleSelection[data].id.toString() : ids.concat("," + this.multipleSelection[data].id.toString());
      }

      _httpUtils.default.post("agentSystemConfig", "approveFailAgentConfigs", null, ids).then(function (res) {
        if (res.code === 200) {
          _this8.$notify({
            title: _lang.default.t("SMS.success"),
            message: _lang.default.t("message.message11"),
            type: "success",
            duration: 2000
          });

          _this8.getList();
        } else {
          _this8.$message({
            showClose: true,
            message: _lang.default.t("message.message12"),
            type: "warning"
          });
        }
      }).catch(function (err) {
        _this8.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleDelete: function handleDelete(id) {
      var _this9 = this;

      var content = _lang.default.t('warningMessage.deleteAgentSystemConfigConfirmMessage');

      this.$confirm(content, _lang.default.t('warningMessage.deleteAgentSystemConfigMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _httpUtils.default.post("agentSystemConfig", "delete", null, id).then(function (res) {
          if (res.code === 200) {
            _this9.$message({
              message: _lang.default.t('warningMessage.deleteAgentSystemConfigSuccessMessage'),
              type: 'success'
            });

            _this9.handleFilter();
          } else {
            _this9.$message({
              message: res.message,
              type: 'error'
            });
          }
        }).catch(function (err) {
          _this9.$message({
            message: err.message,
            type: 'error'
          });
        });
      }).catch(function (_) {});
    },
    checkSelection: function checkSelection() {
      var message, info;

      if (this.multipleSelection === undefined ? true : this.multipleSelection.length === 0) {
        message = _lang.default.t("message.message16");
        info = _lang.default.t("SMS.alarm");
        this.$message(message, info, {
          confirmButtonText: _lang.default.t("permission.confirm"),
          type: "warning"
        });
        return true;
      }
    }
  }
};
exports.default = _default;